import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import styled from "styled-components";

const Wrapper = styled.section`
  min-height: 70vh;
  display: grid;
  place-items: center;
  padding: 120px 8vw 80px;
`;

const Card = styled.div`
  max-width: 620px;
  width: 100%;
  padding: 40px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: center;
`;

const Eyebrow = styled.p`
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--accent-2);
  font-size: 12px;
  margin-bottom: 16px;
`;

const Title = styled.h1`
  font-family: "DM Serif Display", serif;
  font-size: clamp(2rem, 4vw, 3.4rem);
  margin-bottom: 16px;
`;

const Text = styled.p`
  color: var(--muted);
  line-height: 1.7;
  margin-bottom: 28px;
`;

const CTA = styled(Link)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 14px 24px;
  border-radius: 999px;
  background: var(--accent);
  color: #0b0b0d;
  font-size: 13px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-weight: 700;
`;

function NotFound() {
  return (
    <Wrapper>
      <Helmet>
        <title>Page Not Found — RMS</title>
        <meta
          name="description"
          content="The page you’re looking for is no longer available. Explore the RMS catalog, company profile, or contact page."
        />
      </Helmet>
      <Card>
        <Eyebrow>404</Eyebrow>
        <Title>This page is off the record.</Title>
        <Text>
          The link you followed does not currently exist. Head back to the RMS home page,
          explore the catalog, or contact the team for publishing and partnership inquiries.
        </Text>
        <CTA to="/">Back to home</CTA>
      </Card>
    </Wrapper>
  );
}

export default NotFound;
